import type { RgbaTuple } from "../fill/fillTypes";

export function hexToRgba(colour: string, opacity = 1): RgbaTuple {
  const match = /^#([0-9a-f]{6})$/i.exec(colour);
  if (!match) return [0, 0, 0, Math.round(Math.min(1, Math.max(0, opacity)) * 255)];
  const value = Number.parseInt(match[1]!, 16);
  return [
    (value >> 16) & 255,
    (value >> 8) & 255,
    value & 255,
    Math.round(Math.min(1, Math.max(0, opacity)) * 255),
  ];
}

export function rgbaToHex(pixel: RgbaTuple): string | null {
  if (pixel[3] === 0) return null;
  return `#${[pixel[0], pixel[1], pixel[2]]
    .map((value) =>
      Math.min(255, Math.max(0, Math.round(value)))
        .toString(16)
        .padStart(2, "0"),
    )
    .join("")}`.toUpperCase();
}
